// Add your custom JS here.
import Swiper from 'swiper';
import UIKit from 'uikit';
import { EffectFade, Navigation } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {

    // SmartCircle Block Slider
    new Swiper('.smartcircle-slider', {
        loop: true,
        speed: 500,
        allowTouchMove: true,
        slidesPerView: 1,
        centeredSlides: true,
        initialSlide: 1,
        spaceBetween: 0,
        autoHeight: true,
        infinite: true,
        effect: 'fade',
        modules: [EffectFade, Navigation],
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // Clients Block Slider
    new Swiper('.logos-slider', {
        loop: true,
        speed: 500,
        allowTouchMove: true,
        slidesPerView: 2,
        centeredSlides: true,
        spaceBetween: 12,
        infinite: true,
        modules: [Navigation],
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 32,
                initialSlide: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1320: {
                slidesPerView: 5,
            },
            1600: {
                slidesPerView: 6,
            }
        }
    });

    // Gallery Slider Block
    new Swiper('.gallery-slider', {
        loop: true,
        speed: 1000,
        allowTouchMove: true,
        slidesPerView: 2,
        centeredSlides: true,
        spaceBetween: 16,
        infinite: true,
        modules: [Navigation],
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 32
            },
            1024: {
                slidesPerView: 4,
            },
            1320: {
                slidesPerView: 5,
            }
        }
    });

    // Gallery Modal Slider
    new Swiper('.gallery-modal-slider', {
        loop: true,
        speed: 500,
        allowTouchMove: true,
        slidesPerView: 1,
        centeredSlides: true,
        initialSlide: 1,
        spaceBetween: 0,
        autoHeight: true,
        infinite: true,
        effect: 'fade',
        modules: [EffectFade, Navigation],
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
});


jQuery(function($) {
    
    // When scrolled passed the header, add a class to the navbar
    function checkScroll() {
        if ($(window).scrollTop() > 600) {
            $('#main-nav').addClass('scrolled').removeClass('scroll-transition');
        } else if ($(window).scrollTop() > 200 && $(window).scrollTop() < 600) {
            $('#main-nav').addClass('scrolled').addClass('scroll-transition');
        } else {
            $('#main-nav').removeClass('scrolled').removeClass('scroll-transition');
        }
    }

    // Run on load
    checkScroll();

    // Run on scroll
    $(window).scroll(checkScroll);

    // Scrollspy Elements
    $(window).load(function () {
        $('.scroll-in').attr('uk-scrollspy', 'cls: uk-animation-slide-bottom-medium; repeat: true; delay: 100');
        $('.fade-in').attr('uk-scrollspy', 'cls: uk-animation-fade; repeat: true; delay: 100');
        $('.scroll-in-children').attr('uk-scrollspy', 'target: > *; cls: uk-animation-slide-bottom-medium; repeat: true; delay: 100');
    });

    // toTopButton
    $(window).scroll(function() {
        if ($(this).scrollTop() > 600) {
            $('#toTopButton').removeClass('hidden');
        } else {
            $('#toTopButton').addClass('hidden');
        }
    });
    // Smoothly scroll back to top when the button is clicked
    $('#toTopButton').click(function(event) {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});